import AppConstants from "../config/app.constants";

let StopSchedulingService = ($http) => {

    let createStopScheduling = (data) => {
        return $http
            .post(AppConstants.api + `/stop-scheduling/create-stop-scheduling`, { data })
            .then((res) => {
                return res.data
            })
    }

    let getPendingChanges = (startDate, endDate, branchId, searchText) => {
        return $http
            .get(AppConstants.api + `/stop-scheduling/get-pending-changes`, {
                params: { startDate, endDate, branchId, searchText }
            })
            .then((res) => {
                return res.data
            })
    }

    let cancelScheduledStops = (jobKey) => {
        return $http
            .post(AppConstants.api + `/stop-scheduling/cancel-scheduled-stop`, { jobKey })
            .then((res) => {
                return res.data
            })
    }
    return {
        createStopScheduling, getPendingChanges, cancelScheduledStops
    }

}
StopSchedulingService.$inject = ['$http'];

export default StopSchedulingService;


// WEBPACK FOOTER //
// ./client/app/services/stop-scheduling.service.js